import * as THREE from 'three';
import { woodMaterial } from './materials.js';
import { mat, PALETTE } from './palette.js';

/** Detalle piloto salón (CL-VIVO-008) — zona -8,2 sin tocar el resto del local. */
export function buildPilotSalonDetail(parent: THREE.Group): void {
  const booth = new THREE.Mesh(new THREE.BoxGeometry(3.6, 1.05, 1.4), woodMaterial(4, 0x8b5a38));
  booth.position.set(-12.5, 0.52, 4);
  booth.castShadow = true;
  booth.receiveShadow = true;
  const cushion = new THREE.Mesh(
    new THREE.BoxGeometry(3.4, 0.22, 1.2),
    mat(0x6b2d2d, { roughness: 0.92 }),
  );
  cushion.position.set(-12.5, 1.08, 4);
  const rail = new THREE.Mesh(new THREE.BoxGeometry(3.8, 0.08, 0.12), woodMaterial(2, 0x5c3a22));
  rail.position.set(-12.5, 1.25, 3.25);
  const sign = new THREE.Mesh(new THREE.BoxGeometry(2.2, 0.55, 0.08), mat(PALETTE.brand, { roughness: 0.5 }));
  sign.position.set(-8, 2.45, 6.5);
  parent.add(booth, cushion, rail, sign);
}
